import { ref } from 'vue';

/**
 * Tooltip instantaneo que segue o mouse — o hover dos graficos dos
 * relatorios (mesmo comportamento do prototipo aprovado; o title nativo
 * demora ~1s pra aparecer e nao acompanha o cursor).
 *
 * Uso: const { tip, showTip, hideTip } = useHoverTip();
 * No template: @mousemove="showTip($event, 'texto')" @mouseleave="hideTip"
 * e um <div v-if="tip" class="fixed z-50 ..." :style="tipStyle(tip)">.
 */
export function useHoverTip() {
  const tip = ref(null);

  const showTip = (event, text) => {
    tip.value = { x: event.clientX, y: event.clientY, text };
  };
  const hideTip = () => {
    tip.value = null;
  };
  const tipStyle = value => ({
    left: `${Math.min(value.x + 12, window.innerWidth - 240)}px`,
    top: `${value.y + 14}px`,
  });

  return { tip, showTip, hideTip, tipStyle };
}
